module.exports = __webpack_public_path__ + "img/16m008-15.87bea74c.jpg";